/** Таймаут для старта чек-листа: на test/prod API иногда отвечает >15s (общий backend). */
export const CHECKLIST_LEAD_TIMEOUT_MS = 90000;

export async function postChecklistLead(body) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CHECKLIST_LEAD_TIMEOUT_MS);
  try {
    const res = await fetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    if (!res.ok) {
      const errText = await res.text();
      let detail = '';
      try {
        detail = JSON.parse(errText)?.detail || '';
      } catch {
        detail = '';
      }
      if (Array.isArray(detail)) detail = detail.map((item) => item.msg).filter(Boolean).join(' ');
      console.error('Checklist leads failed:', res.status, errText);
      return { ok: false, status: res.status, detail: typeof detail === 'string' ? detail : '' };
    }
    return { ok: true, status: res.status };
  } catch (err) {
    const aborted = err.name === 'AbortError';
    console.error('Checklist leads error:', aborted ? 'timeout' : err.message);
    return { ok: false, status: aborted ? 408 : 0 };
  } finally {
    clearTimeout(timer);
  }
}

/** Завершение чек-листа: не блокируем UI, keepalive для навигации со страницы. */
export function postChecklistCompletion(body) {
  fetch('/api/consultation-request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch((err) => console.error('Checklist completion error:', err.message));
}

/** Запрос полного отчёта sales-чек-листа с HTML-вёрсткой письма. */
export async function postChecklistReportRequest(body) {
  try {
    const res = await fetch('/api/consultation-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const errText = await res.text();
      let detail = '';
      try {
        detail = JSON.parse(errText)?.detail || '';
      } catch {
        detail = '';
      }
      if (Array.isArray(detail)) detail = detail.map((item) => item.msg).filter(Boolean).join(' ');
      console.error('Checklist report request failed:', res.status, errText);
      return { ok: false, status: res.status, detail: typeof detail === 'string' ? detail : '' };
    }
    const data = await res.json().catch(() => ({}));
    return { ok: true, status: res.status, userEmailSent: Boolean(data.userEmailSent) };
  } catch (err) {
    console.error('Checklist report request error:', err.message);
    return { ok: false, status: 0 };
  }
}
